export default {
  home: {
    sections: {
      trendingParlays: "Beliebte Kombiwetten des Tages",
    },
    checkout: {
      placeItOn: "Wette bei",
    },
    matchups: {
      today: "Heutige Matchups",
      thisWeek: "Matchups dieser Woche",
      upcoming: "Kommende Matchups",
    },
    actions: {
      claimNow: "Jetzt sichern",
      showMore: "Mehr anzeigen",
      showLess: "Weniger anzeigen",
    },
    empty: {
      parlayMinGames: "Noch keine Trends verfügbar. Mindestens 3 Spiele erforderlich.",
    },
    hundredPercentClub: {
      subtitle: "Props, die in 100% der Spiele getroffen haben",
    },
    advancedTools: {
      subtitles: {
        startingLineups: "Finde Value, wenn sich Startaufstellungen ändern. Enthalten mit",
        injuryImpact: "Sieh, wie Verletzungen Teamkollegen beeinflussen. Enthalten mit",
        opponentRank: "Nutze günstige defensive Matchups aus. Enthalten mit",
        startingPitchers: "Ziele auf Spots gegen anfällige Pitcher. Enthalten mit",
        weatherReport: "Nutze Wind und Wetter zu deinem Vorteil. Enthalten mit",
      },
    },
    predictionMarkets: {
      status: {
        loading: "Märkte werden geladen...",
        loadError: "Märkte konnten nicht geladen werden.",
      },
    },
    sidebar: {
      downloadApp: "App herunterladen",
      neverMissTrend: "Verpasse keinen Trend",
      unlockAnalysis: "Schalte die vollständige Analyse frei",
      unlock: "Freischalten",
      mostBetOn: "Am häufigsten gewettet",
      mostSearched: "Am häufigsten gesucht",
      trendingLeagues: "Beliebte Ligen",
      topOffers: "Top {{type}}",
      newsletter: {
        title: "Sei den Trends einen Schritt voraus",
        description: "Schließe dich <strong>über 30.000 Sportwettern</strong> an, die Analysen und Angebote von Linemate per E-Mail erhalten.",
        subscribe: "Abonnieren",
        subscribedTitle: "Du bist angemeldet!",
        subscribedBody: "Wir senden dir die neuesten Trends und Angebote von Linemate per E-Mail.",
      },
      improveExperience: "Verbessere dein Linemate-Erlebnis",
      getAccess: "ERHALTE ZUGANG ZU ERWEITERTEN PLAYS UND TIEFEREN EINBLICKEN",
    },
  },
};
